import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Utils } from '../../shared/utils/utils';
import { loadTranslations } from '@angular/localize';
import { getTranslations } from '@soluling/angular';
import "@angular/localize/init";

const locale = Utils.getQueryParam('locale');

const win: any = window || {}
if (win['__env']['production']) {
  enableProdMode();
}

getTranslations("/assets/localization", false, true, true, 'en', locale ?? undefined, undefined).then(translations => {
  if (translations) loadTranslations(translations);

  import("./app/app.module").then(module => {
    platformBrowserDynamic()
      .bootstrapModule(module.AppModule)
      .catch(err => console.error(err));
  });
});
